module.exports = __webpack_public_path__ + "img/menu-action-icon.766647f7.svg";